<template>
  <div class="container">
    <div class="content">
      <mainMenu>
        <!-- Cart button -->
        <!-- <btn btnColor="btn btn-small btn-info btn-popup"
           :cartIcon="true"
           @click.native="showPopupCart()">
           Cart
          <span class="btn-circle" v-if="hasProduct()">
             {{ getProductsInCart.length }}
          </span>
        </btn>
        <transition name="appear">
          <popupcart class="cart" v-if="getPopupCart"/>
        </transition> -->
      </mainMenu>
      <carousel :autoplay="true"
                :loop="false"
                :autoplayTimeout="4000"
                :speed="1000"
                :autoplayHoverPause="false"
                :perPage="1"
                :navigationEnabled="false">
        <!--
        Images and code generated using https://www.responsivebreakpoints.com
          Parameters:
            Resolution: 400 to 1200px
            Size step: 64 KB
            Maximum images: 5
            Include double resolution: Yes
            Art direction:  Tablets 16:9, 100%
                            Smartphones: 4:3, 100%
        -->
        <slide class="img-banner">
            <picture>
              <source
              media="(max-width: 767px)"
              sizes="(max-width: 1534px) 100vw, 1534px"
              srcset="
              ./assets/images/carousel/carousel_1_quelbo_ar_4_3_w_400.jpg 400w,
              ./assets/images/carousel/carousel_1_quelbo_ar_4_3_w_1164.jpg 1164w,
              ./assets/images/carousel/carousel_1_quelbo_ar_4_3_w_1534.jpg 1534w">
              <img
              sizes="(max-width: 2400px) 100vw, 2400px"
              srcset="
              ./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_768.jpg 768w,
              ./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_1341.jpg 1341w,
              ./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_1763.jpg 1763w,
              ./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_2213.jpg 2213w,
              ./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_2400.jpg 2400w"
              src="./assets/images/carousel/carousel_1_quelbo_ar_16_9_w_2400.jpg"
              alt="">
            </picture>
        </slide>
        <slide class="img-banner">
          <picture>
            <source
            media="(max-width: 767px)"
            sizes="(max-width: 1534px) 100vw, 1534px"
            srcset="
            ./assets/images/carousel/carousel_2_klrq02_ar_4_3_w_400.jpg 400w,
            ./assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1086.jpg 1086w,
            ./assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1465.jpg 1465w,
            ./assets/images/carousel/carousel_2_klrq02_ar_4_3_w_1534.jpg 1534w">
            <img
            sizes="(max-width: 2400px) 100vw, 2400px"
            srcset="
            ./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_768.jpg 768w,
            ./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_1335.jpg 1335w,
            ./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_1747.jpg 1747w,
            ./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_2154.jpg 2154w,
            ./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_2400.jpg 2400w"
            src="./assets/images/carousel/carousel_2_klrq02_ar_16_9_w_2400.jpg"
            alt="">
          </picture>
        </slide>
        <slide class="img-banner">
          <picture>
            <source
            media="(max-width: 767px)"
            sizes="(max-width: 1534px) 100vw, 1534px"
            srcset="
            ./assets/images/carousel/carousel_3_optyeh_ar_4_3_w_400.jpg 400w,
            ./assets/images/carousel/carousel_3_optyeh_ar_4_3_w_1224.jpg 1224w,
            ./assets/images/carousel/carousel_3_optyeh_ar_4_3_w_1534.jpg 1534w">
            <img
            sizes="(max-width: 2400px) 100vw, 2400px"
            srcset="
            ./assets/images/carousel/carousel_3_optyeh_ar_16_9_w_768.jpg 768w,
            ./assets/images/carousel/carousel_3_optyeh_ar_16_9_w_1596.jpg 1596w,
            ./assets/images/carousel/carousel_3_optyeh_ar_16_9_w_1976.jpg 1976w,
            ./assets/images/carousel/carousel_3_optyeh_ar_16_9_w_2400.jpg 2400w"
            src="./assets/images/carousel/carousel_3_optyeh_ar_16_9_w_2400.jpg"
            alt="">
          </picture>
        </slide>
        <slide class="img-banner">
          <picture>
            <source
            media="(max-width: 767px)"
            sizes="(max-width: 1534px) 100vw, 1534px"
            srcset="
            ./assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_400.jpg 400w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_900.jpg 900w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1200.jpg 1200w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1477.jpg 1477w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_4_3_w_1534.jpg 1534w">
            <img
            sizes="(max-width: 2400px) 100vw, 2400px"
            srcset="
            ./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_768.jpg 768w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_1338.jpg 1338w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_1742.jpg 1742w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_2150.jpg 2150w,
            ./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_2400.jpg 2400w"
            src="./assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_2400.jpg"
            alt="">
          </picture>
        </slide>
        <slide class="img-banner">
          <picture>
            <source
            media="(max-width: 767px)"
            sizes="(max-width: 1534px) 100vw, 1534px"
            srcset="
            ./assets/images/carousel/carousel_5_nx3ajx_ar_4_3_w_400.jpg 400w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_4_3_w_1075.jpg 1075w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_4_3_w_1534.jpg 1534w">
            <img
            sizes="(max-width: 2400px) 100vw, 2400px"
            srcset="
            ./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_768.jpg 768w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_1413.jpg 1413w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_1757.jpg 1757w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_2156.jpg 2156w,
            ./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_2400.jpg 2400w"
            src="./assets/images/carousel/carousel_5_nx3ajx_ar_16_9_w_2400.jpg"
            alt="">
          </picture>
        </slide>
      </carousel>
      <transition name="component-fade" mode="out-in">
        <router-view></router-view>
      </transition>
      <!-- <maskBg v-if="getPopupCart" @click.native="showPopupCart()"/> -->
    </div>
    <footer>
      <div class="footer-inner">
        <svg class="logo" viewBox="0 0 256 160">
          <polygon class="st0" points="157.86,96 239.98,16 200,16 194.12,16 112,16 112,48 161.27,48
          116.75,91.37 155.67,128 240,128 240,96 "/>
          <polygon class="st0" points="88.1,75.39 144,16 100.06,16 56.7,62.07 48,71.31 48,16 16,16
          16,105.31 16,112 16,152 66.17,98.69 76.06,108 97.31,128 144,128 97.99,84.7 "/>
        </svg>
        <p class="ig-link">
          <img class="ig-logo" src="./assets/images/icons/instagram-logo.svg" alt="Instagram logo">
          <a href="https://www.instagram.com/kiting_zone"> Follow us on Instagram</a>
        </p>
        <p>&copy; Copyright {{new Date().getFullYear()}} Kiting Zone</p>
        <p>Design by <a href="http://tgy.al">tgy.al</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { Carousel, Slide } from 'vue-carousel';
import mainMenu from './components/Menu';
import btn from './components/Btn';
import popupcart from './components/Popupcart';
import maskBg from './components/Mask';


export default {
  components: {
    Carousel,
    Slide,
    mainMenu,
    btn,
    popupcart,
    maskBg,
  },
  methods: {
    ...mapActions([
      'showOrHiddenPopupCart',
    ]),
    hasProduct() {
      return this.getProductsInCart.length > 0;
    },
    showPopupCart() {
      this.showOrHiddenPopupCart();
    },
  },
  computed: {
    ...mapGetters([
      'getProductsInCart',
      'getPopupCart',
    ]),
  },
};
</script>

<style>
  @import './assets/css/normalize.css';
  @import url('https://fonts.googleapis.com/css2?family=Archivo:wght@800&family=Chivo:wght@400;700&display=swap');

  body {
    font-family: 'Chivo', sans-serif;
    font-weight: 400;
    background-color: #4F5D75;
    color: #E8EAED;
  }

  h1, h2 {
    font-family: 'Archivo';
    font-weight: 800;
    color: #fff;
  }

  h1 {
    text-align: center;
    padding-bottom: 8px;
    margin: 0 auto 36px auto;
  }

  h1::after {
    content: "";
    display: block;
    border-bottom: 2px solid rgba(0,0,0,.6);
    width: 25%;
    max-width: 150px;
    position: relative;
    bottom: -10px; /* your padding + border-width */
    margin: 0 auto;
  }

  h3 {
    font-size: 1em;
  }

  a {
    color: #fff;
    text-decoration: none;
    cursor: pointer;
    transition: 0.2s;
  }

  p {
    line-height: 1.5;
  }

  p a {
    border-bottom: 2px solid transparent;
    padding-bottom: 0.2em;
  }

  p a:hover {
    border-bottom: 2px solid rgba(0,0,0,.6);
  }

  .container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  .content {
    flex: 1 0 auto;
  }

  footer {
    display: block;
    width: 100%;
    background-color: #2D3142;
    color: #9CA4B1;
    margin-top:auto;
    flex-shrink: 0;
  }

  .footer-inner {
    min-height: 74px;
    max-width: 1080px;
    padding: 2em 1em;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  footer .logo {
    height: 42px;
    opacity: 0.7;
    fill: #9CA4B1;
    margin-bottom: 0.5em;
  }

  footer .ig-link {
    display: flex;
    align-items: center;
    gap: 0.5em;
  }

  footer .ig-link a {
    display: flex;
    align-items: center;
  }

  footer .ig-logo {
    height: 1.25em;
    position: relative;
    top: -0.2em;
  }

  footer p{
    font-size: 14px;
    margin-bottom: 0;
    margin-top: 0.25em;
  }

  footer p:last-child {
    margin-bottom: 0;
  }

  footer a {
    color: inherit;
  }

  footer a:hover {
    color: #bec5d1;
  }

  .strikethrough {
    text-decoration: line-through;
  }

  .white-bg{
    background-color: #fff;
    color: #8c94a1;
    box-shadow:
      0 3.3px 5.3px rgba(0, 0, 0, 0.04),
      0 11.2px 17.9px rgba(0, 0, 0, 0.06),
      0 50px 80px rgba(0, 0, 0, 0.1)
    ;
  }

  .white-bg a, .white-bg h1, .white-bg h2, .white-bg h3{
    color: #8c94a1;
  }

  .text-container {
    width: 100%;
    max-width: 832px;
    padding: 4em 0;
    margin: 0 auto;
  }

  .text-inner {
    padding: 0 1em;
    display: flex;
    flex-direction: column;
  }

  .VueCarousel-pagination {
    position: absolute;
    bottom: 0;
  }

  .VueCarousel-navigation-prev, .VueCarousel-navigation-next {
    transform: translateY(-50%) translateX(0);
  }

  .img-banner {
    overflow: hidden;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-banner picture{
    width: 100%;
  }

  @media screen and (min-width: 800px) {
    .VueCarousel-inner .img-banner:last-child picture{
      margin-bottom: 5%;
    }
  }

  @media screen and (min-width: 1100px) {
    .VueCarousel-inner .img-banner:last-child picture{
      margin-bottom: 15%;
    }
  }

  @media screen and (max-width: 800px) {
    .img-banner {
      height: 350px;
    }
  }

  @media screen and (max-width: 600px) {
    .img-banner {
      height: 300px;
    }
  }

  @media screen and (max-width: 400px) {
    .img-banner picture{
      width: 110%;
    }
    .img-banner {
      height: 250px;
    }
  }

  .cart {
    position: absolute;
    top: 75px;
    right: 300px;
  }

  .btn-circle {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #fff;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pre-formatted {
    white-space: pre-line;
  }

  .disciplines {
    display: flex;
    list-style: none;
    padding: 0;
  }

  .disciplines li {
    text-align: center;
    background-color: #E0E1E3;
    border-radius: 1em;
    padding: 5px 12px 4px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    color: #2D3142;
  }

  .disciplines li.kite {
    background-color: #f7d07f;
  }

  .disciplines li.wing {
    background-color: #87b4fa;
  }

  .disciplines li.wind {
    background-color: #f98a76;
  }

  .disciplines li.surf {
    background-color: #95ec7d;
  }

  .disciplines li.pump {
    background-color: #D3A2E6;
  }

  .disciplines li.dw {
    background-color: #7ca17c;
  }

  .product-price {
    align-self: flex-start;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .stock-status-color {
    display: block;
    height: 10px;
    width: 10px;
    border-radius: 6px;
    background-color: #f98a76; /* red (out of stock) */
  }

  .stock-status-color.in-stock {
    background-color: #91e978;
  }

  .deal-sticker {
    text-align: center;
    border-radius: 1em;
    border: 2px solid #FA5E42;
    padding: 4px 12px 3px;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
    color: #FA5E42;
  }

  .deal-price {
    color: #FA5E42;
  }

  .component-fade-enter-active, .component-fade-leave-active {
    transition: all 0.25s;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
    transform: translateX(-10%);
  }

  .appear-enter-active {
    animation: appear-animation .5s;
  }

  .appear-leave-active {
    animation: appear-animation .5s reverse;
  }

  @keyframes appear-animation {
    0% {
      transform: translateY(-50%);
      opacity: 0;
    }
    100% {
      transform: translateY(0%);
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue